module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vnerv7-e22e4ba67be0f17c886fb0114ea205da.jpg";